import styled from "styled-components";

export const BrandSwitchListItemIconBox = styled.i`
  background-image: url("${props => props.theme.images.spriteSheet.toString()}");
  background-repeat: no-repeat;
  display: inline-block;
  width: 30px;
  height: 20px;
  margin: 0 0 0.5rem 0;
  
  &.com-brand {
    background-position: -43px -681px;
  }
  &.poker-brand {
    background-position: -103px -681px;
  }
  &.sport-brand {
    background-position: -158px -681px
  }
  &.bingo-brand {
    background-position: -213px -681px;
  }
  &.casino-brand {
    background-position: -268px -681px;
  }
  &.games-brand {
    background-position: -323px -681px;
  }
`